var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstandhaltungstechniker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34.7 63.1",
    style: {
      enableBackground: "new 0 0 34.7 63.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.5,18.9h-9.1c-0.7,0-1.3-0.5-1.4-1.2c-0.6-4-3.3-4.9-3.9-5.1h-1l-0.4,0.9c-0.2,0.5-0.7,0.9-1.3,0.9h-4 C0.6,14.4,0,13.8,0,13V4.3c0-0.8,0.6-1.4,1.4-1.4H5c0.4,0,0.8,0.2,1,0.5l1.2,1.4h1.2l2.8-4.1C11.6,0.2,12,0,12.5,0h9.3 c0,0,0,0,0.1,0c0.1,0,2.6,0.1,5.4,1.7c2.6,1.4,6,4.4,7.4,10.4c0.1,0.6-0.1,1.2-0.6,1.5l-0.4,0.3c-0.6,0.4-1.3,0.3-1.8-0.2 c-1-1.1-3.5-3.2-5.1-2.9c-0.6,0.1-1,0.7-1.4,1.7l-1.6,5.5C23.6,18.5,23.1,18.9,22.5,18.9z M14.5,16.1h6.9l1.3-4.6 C23.6,9,25.1,8.2,26.2,8c1.5-0.3,3,0.3,4.3,1c-3-5.7-8.4-6.2-8.8-6.2h-8.5l-2.8,4.1c-0.3,0.4-0.7,0.6-1.2,0.6H6.7 c-0.4,0-0.8-0.2-1-0.5L4.4,5.7H2.8v6h1.7l0.4-0.9c0.2-0.5,0.7-0.9,1.3-0.9h2.1c0.1,0,0.2,0,0.3,0C8.7,9.9,13.1,10.7,14.5,16.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,25.1h-9.1c-0.8,0-1.4-0.6-1.4-1.4v-6.2c0-0.8,0.6-1.4,1.4-1.4h9.1c0.8,0,1.4,0.6,1.4,1.4v6.2 C23.8,24.5,23.2,25.1,22.4,25.1z M14.7,22.3H21v-3.4h-6.3V22.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,38.5h-3.9c-0.8,0-1.4-0.6-1.4-1.4V23.7c0-0.8,0.6-1.4,1.4-1.4h3.9c0.8,0,1.4,0.6,1.4,1.4v13.4 C21.2,37.9,20.6,38.5,19.8,38.5z M17.3,35.7h1.1V25.1h-1.1V35.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.4,63.1H11.3c-0.4,0-0.8-0.2-1-0.5c-0.3-0.3-0.4-0.7-0.3-1.1c0.2-1.9,1.1-3,2-3.6V39.6 c0.1-3,2-3.9,2.9-3.9l5.9,0c1,0,2.9,0.9,3,3.8l0,18.4c0.9,0.6,1.8,1.7,2,3.6c0,0.4-0.1,0.8-0.3,1.1 C25.2,62.9,24.8,63.1,24.4,63.1z M13.4,60.3h9c-0.2-0.2-0.3-0.2-0.3-0.2c-0.6-0.2-1-0.7-1-1.3V39.6c0-0.7-0.3-1-0.4-1.1l-5.5,0 c-0.1,0.1-0.3,0.4-0.4,1.2l0,19.1c0,0.6-0.4,1.2-1,1.4C13.7,60.1,13.5,60.1,13.4,60.3z M20.6,38.5L20.6,38.5L20.6,38.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstandhaltungstechniker);
export default __webpack_public_path__ + "static/media/Instandhaltungstechniker.bccb285c36bd525620f4a84e3335ac14.svg";
export { ForwardRef as ReactComponent };